import { Component } from '@angular/core';
import { CancelPolicyComponent } from '../cancel-policy/cancel-policy.component';

// only change is template
@Component({
  selector: 'cancel-policy',
  moduleId: module.id,
  templateUrl: './cancel-policy-simple.component.html',
})
export class CancelPolicySimpleComponent extends CancelPolicyComponent {}
